































// import React, { useState } from "react";
// import { Link, useParams } from "react-router-dom";
// import Logo from "../../assets/Images/companyName.svg";
// import Header from "../../component/Header";
// import { BiFile } from "react-icons/bi";
// import { useSelector } from "react-redux";
// import JobCard from "../../component/JobCard";
// import { useFetchData } from "../../hooks/useFtechData";
// import { ALL_JOB, APPLICATION_API, INTERVIEW_API } from "../../resources/resource";
// import Loader from "../../component/utilities/Loader";
// import PDFPreviewModal from "../../component/pdf/CvPreview";
// import { getSimilarJobs } from "../job/data";
// import GeneralModal from "../../component/Modals/General.modal";
// import InterviewDetails from "./InterviewDetails";
// import { toast } from "react-toastify";
// import { useMakeRequest } from "../../hooks/useMakeRequest";

// function ApplicantResponse() {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [viewInterviewDetail, setViewInterviewDetails] = useState(false);
//   const [responses, setResponses] = useState({});
//   const [submitLoading, setSubmitLoading] = useState(false);
//   const applicationId = useParams().applicationId;
//   const loggedInUser = useSelector((state) => state.user);
//   const makeRequest = useMakeRequest();

//   const { data, loading } = useFetchData(
//     APPLICATION_API + `/getAnApplication/${applicationId}`
//   );
//   const { data: jobData } = useFetchData(ALL_JOB);
//   const latestOffer = data?.jobOffers[data?.jobOffers?.length - 1];

//   // Fetch interview data for the application
//   const latestInterviewId = data?.interviews[data?.interviews?.length - 1];
//   console.log('Latest Interview ID:', latestInterviewId); // Debugging
//   console.log('Application Data:', data); // Debugging
//   const { data: interviewData, loading: interviewLoading } = useFetchData(
//     latestInterviewId
//       ? `${INTERVIEW_API}/getAnInterview`
//       : null,
//     {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ interviewId: latestInterviewId }),
//     }
//   );
//   console.log('Interview Data:', interviewData); // Debugging

//   // Check if today is the interview date
//   const today = new Date().toISOString().split("T")[0];
//   const isInterviewDate = interviewData?.data?.interviewDate === today;
//   console.log('Is Interview Date:', isInterviewDate, 'Interview Date:', interviewData?.data?.interviewDate, 'Today:', today); // Debugging

//   const renderStatus = (status) => {
//     const statuses = [
//       "Applied",
//       "Shortlisted",
//       "Scheduled",
//       "Interviewed",
//       "Offer",
//       "Hired",
//     ];
//     const currentIndex = statuses.indexOf(data?.status);
//     return (
//       <div className="flex items-center space-x-4 overflow-x-auto pb-4">
//         {statuses.map((s, index) => (
//           <div key={index} className="flex items-center">
//             <div className="relative flex items-center mt-8">
//               <div
//                 className={`w-24 h-1 ${
//                   currentIndex >= index ? "bg-blue-600" : "bg-gray-200"
//                 }`}
//               ></div>
//               <div
//                 className={`w-3 h-3 rounded-full ${
//                   currentIndex >= index ? "bg-blue-600" : "bg-gray-200"
//                 } 
//                 transition-all duration-300`}
//               >
//                 <span
//                   className={`absolute -top-5 left-1/2 -translate-x-1/2 text-xs whitespace-nowrap 
//                   ${
//                     currentIndex >= index
//                       ? "text-blue-600 font-medium"
//                       : "text-gray-400"
//                   }`}
//                 >
//                   {s}
//                 </span>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     );
//   };

//   const openModal = () => setIsModalOpen(true);

//   const handleResponseChange = (questionIndex, value) => {
//     setResponses((prev) => ({
//       ...prev,
//       [questionIndex]: value,
//     }));
//   };

//   const handleSubmitResponses = async (e) => {
//     e.preventDefault();
//     setSubmitLoading(true);
//     try {
//       const responseArray = interviewData?.data?.questions.map((q, index) =>
//         responses[index] || q.response || ""
//       );
//       await makeRequest(
//         `${INTERVIEW_API}/submitInterviewResponses`,
//         "POST",
//         { interviewId: latestInterviewId, responses: responseArray },
//         () => {
//           toast.success("Responses submitted successfully", {
//             style: { background: "#16a34a", color: "white" },
//           });
//           setResponses({});
//         },
//         (error) => {
//           toast.error(error.message || "Failed to submit responses", {
//             style: { background: "#D33636", color: "white" },
//           });
//         },
//         () => {
//           setSubmitLoading(false);
//         }
//       );
//     } catch (error) {
//       console.error("Error submitting responses:", error);
//       toast.error("Failed to submit responses", {
//         style: { background: "#D33636", color: "white" },
//       });
//       setSubmitLoading(false);
//     }
//   };

//   if (loading || interviewLoading) return <Loader />;

//   return (
//     <div className="min-h-screen bg-gray-50 sm:px-8 px-4 py-16">
//       <Header darkMode={true} />
//       <div className="max-w-7xl mx-auto mt-8">
//         {/* Main Grid - Stacks on mobile, 3 columns on large screens */}
//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          
//           {/* Main Content - Takes full width on mobile, 2/3 on lg */}
//           <div className="lg:col-span-2 bg-white rounded-xl shadow-sm p-5 sm:p-6 border border-gray-100">
//             <div className="flex items-start space-x-4">
//               <img
//                 className="w-16 h-16 object-contain rounded-md"
//                 src={data?.companyId?.avatar || Logo}
//                 alt="company logo"
//               />
//               <div>
//                 <h1 className="text-xl font-semibold text-gray-900">
//                   {data?.job?.jobTitle}
//                 </h1>
//                 <p className="text-gray-600">{data?.job?.employerName}</p>
//                 <p className="text-gray-500 text-sm">{data?.job?.state}</p>
//               </div>
//             </div>
//             <Link
//               to={`/profile/${loggedInUser?.currentUser?._id}`}
//               className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors duration-200 text-sm font-medium"
//             >
//               Back
//             </Link>
//           </div>

//           <div className="mt-6 space-y-6">
//             <div>
//               <h3 className="text-lg font-semibold text-gray-900 mb-3">
//                 Application Status
//               </h3>
//               {renderStatus(data?.status)}
//             </div>

//             <div className="flex flex-wrap gap-2">
//               <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm font-medium">
//                 {data?.job?.workType}
//               </span>
//               {data?.job?.currency && data?.job?.salary && (
//                 <span className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm font-medium">
//                   {data?.job?.salary} {data?.job?.currency.split("-")[0]}
//                 </span>
//               )}
//             </div>

//             {data?.job?.jobSummary && (
//               <div>
//                 <h3 className="font-semibold text-gray-900 mb-2">Summary</h3>
//                 <p className="text-gray-600 leading-relaxed">
//                   {data?.job?.jobSummary}
//                 </p>
//               </div>
//             )}

//             {data?.job?.jobDescription && (
//               <div>
//                 <h3 className="font-semibold text-gray-900 mb-2">
//                   Key Responsibilities
//                 </h3>
//                 <ul className="space-y-2 text-gray-600">
//                   {data?.job?.jobDescription?.map((desc, index) => (
//                     <li key={index} className="flex items-start">
//                       <span className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 mr-2 flex-shrink-0"></span>
//                       {desc}
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             )}

//             {data?.requireCoverLetter && (
//               <div>
//                 <h3 className="font-semibold text-gray-900 mb-2">
//                   Cover Letter
//                 </h3>
//                 <p className="text-gray-600 bg-gray-50 p-4 rounded-md">
//                   {data?.coverLetter}
//                 </p>
//               </div>
//             )}

//             {data?.additionalQuestionResponse?.length > 0 && (
//               <div className="space-y-4">
//                 {data.additionalQuestionResponse.map((q, index) => (
//                   <div key={index} className="bg-gray-50 p-4 rounded-md">
//                     <p className="text-gray-700 font-medium">{q.question}</p>
//                     <p className="text-gray-600 mt-1">Answer: {q.response}</p>
//                   </div>
//                 ))}
//               </div>
//             )}

//             <div className="space-y-4">
//               <div className="flex items-center space-x-2 text-gray-700">
//                 <BiFile className="w-5 h-5" />
//                 <span className="font-medium">Resume/CV</span>
//               </div>
//               {data?.resume && (
//                 <div className="bg-orange-50 p-3 rounded-md flex items-center justify-between">
//                   <p className="text-orange-800 font-medium w-fit overflow-auto">
//                     {data?.resume.split(";")[0]}
//                   </p>
//                   <button
//                     onClick={openModal}
//                     className="px-3 py-1 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors duration-200 text-sm"
//                   >
//                     Preview
//                   </button>
//                 </div>
//               )}
//             </div>

//             {data?.status === "Scheduled" && isInterviewDate && interviewData?.data?.questions?.length > 0 && (
//               <div className="space-y-4">
//                 <h3 className="font-semibold text-gray-900 mb-2">
//                   Interview Questions
//                 </h3>
//                 <form onSubmit={handleSubmitResponses}>
//                   {interviewData.data.questions.map((q, index) => (
//                     <div key={index} className="bg-gray-50 p-4 rounded-md mb-4">
//                       <p className="text-gray-700 font-medium">{q.question}</p>
//                       <textarea
//                         value={responses[index] || q.response || ""}
//                         onChange={(e) => handleResponseChange(index, e.target.value)}
//                         className="w-full p-2 border rounded-lg mt-2"
//                         placeholder="Enter your response..."
//                         disabled={q.response}
//                       />
//                     </div>
//                   ))}
//                   <button
//                     type="submit"
//                     className="px-6 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors duration-200"
//                     disabled={submitLoading || interviewData.data.questions.every((q) => q.response)}
//                   >
//                     {submitLoading ? "Submitting..." : "Submit Responses"}
//                   </button>
//                 </form>
//               </div>
//             )}

//             {data?.status === "Offer" && (
//               <Link
//                 to={`/Offer/${latestOffer}/${data?._id}`}
//                 className="inline-block px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors duration-200"
//               >
//                 View Offer
//               </Link>
//             )}
//             {data?.status === "Scheduled" && (
//               <div className="flex items-center justify-start gap-4">
//                 <button
//                   onClick={() => {
//                     setViewInterviewDetails(true);
//                   }}
//                   className="inline-block px-6 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition-colors duration-200"
//                 >
//                   View Details
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>

//         <div className="lg:block hidden space-y-4">
//           {getSimilarJobs(jobData, data?.job)?.map((eachJob, index) => (
//             <JobCard key={index} data={eachJob} />
//           ))}
//         </div>
//       </div>

//       <PDFPreviewModal
//         isOpen={isModalOpen}
//         onClose={() => {
//           setIsModalOpen(false);
//         }}
//         base64Data={data?.resume || ""}
//       />
//       <GeneralModal
//         showCloseButton={true}
//         open={viewInterviewDetail}
//         handleClose={() => setViewInterviewDetails(false)}
//         width={"lg"}
//       >
//         <InterviewDetails
//           interviewData={interviewData?.data}
//         />
//       </GeneralModal>
//     </div>
//   );
// }

// export default ApplicantResponse;



















import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import Logo from "../../assets/Images/companyName.svg";
import Header from "../../component/Header";
import { BiFile } from "react-icons/bi";
import { useSelector } from "react-redux";
import JobCard from "../../component/JobCard";
import { useFetchData } from "../../hooks/useFtechData";
import { ALL_JOB, APPLICATION_API, INTERVIEW_API } from "../../resources/resource";
import Loader from "../../component/utilities/Loader";
import PDFPreviewModal from "../../component/pdf/CvPreview";
import { getSimilarJobs } from "../job/data";
import GeneralModal from "../../component/Modals/General.modal";
import InterviewDetails from "./InterviewDetails";
import { toast } from "react-toastify";
import { useMakeRequest } from "../../hooks/useMakeRequest";

function ApplicantResponse() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [viewInterviewDetail, setViewInterviewDetails] = useState(false);
  const [responses, setResponses] = useState({});
  const [submitLoading, setSubmitLoading] = useState(false);
  const applicationId = useParams().applicationId;
  const loggedInUser = useSelector((state) => state.user);
  const makeRequest = useMakeRequest();

  const { data, loading } = useFetchData(
    APPLICATION_API + `/getAnApplication/${applicationId}`
  );
  const { data: jobData } = useFetchData(ALL_JOB);
  const latestOffer = data?.jobOffers[data?.jobOffers?.length - 1];

  // Fetch interview data for the application
  const latestInterviewId = data?.interviews[data?.interviews?.length - 1];
  const { data: interviewData, loading: interviewLoading } = useFetchData(
    latestInterviewId
      ? `${INTERVIEW_API}/getAnInterview`
      : null,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ interviewId: latestInterviewId }),
    }
  );

  // Check if today is the interview date
  const today = new Date().toISOString().split("T")[0];
  const isInterviewDate = interviewData?.data?.interviewDate === today;

  const renderStatus = (status) => {
    const statuses = [
      "Applied",
      "Shortlisted",
      "Scheduled",
      "Interviewed",
      "Offer",
      "Hired",
    ];
    const currentIndex = statuses.indexOf(data?.status);
    return (
      <div className="flex items-center space-x-4 overflow-x-auto pb-4 scrollbar-hide">
        {statuses.map((s, index) => (
          <div key={index} className="flex items-center flex-shrink-0">
            <div className="relative flex items-center">
              <div
                className={`w-20 sm:w-24 h-1 ${
                  currentIndex >= index ? "bg-blue-600" : "bg-gray-200"
                }`}
              ></div>
              <div
                className={`w-3 h-3 rounded-full ${
                  currentIndex >= index ? "bg-blue-600" : "bg-gray-200"
                } 
                transition-all duration-300`}
              >
                <span
                  className={`absolute -top-6 left-1/2 -translate-x-1/2 text-xs whitespace-nowrap 
                  ${
                    currentIndex >= index
                      ? "text-blue-600 font-medium"
                      : "text-gray-400"
                  }`}
                >
                  {s}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  const openModal = () => setIsModalOpen(true);

  const handleResponseChange = (questionIndex, value) => {
    setResponses((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmitResponses = async (e) => {
    e.preventDefault();
    setSubmitLoading(true);
    try {
      const responseArray = interviewData?.data?.questions.map((q, index) =>
        responses[index] || q.response || ""
      );
      await makeRequest(
        `${INTERVIEW_API}/submitInterviewResponses`,
        "POST",
        { interviewId: latestInterviewId, responses: responseArray },
        () => {
          toast.success("Responses submitted successfully", {
            style: { background: "#16a34a", color: "white" },
          });
          setResponses({});
        },
        (error) => {
          toast.error(error.message || "Failed to submit responses", {
            style: { background: "#D33636", color: "white" },
          });
        },
        () => {
          setSubmitLoading(false);
        }
      );
    } catch (error) {
      console.error("Error submitting responses:", error);
      toast.error("Failed to submit responses", {
        style: { background: "#D33636", color: "white" },
      });
      setSubmitLoading(false);
    }
  };

  if (loading || interviewLoading) return <Loader />;

  return (
    <div className="min-h-screen bg-gray-50 px-4 sm:px-6 lg:px-8 py-12 md:py-16">
      <Header darkMode={true} />

      <div className="max-w-7xl mx-auto mt-8">
        {/* Main Grid - Stacks on mobile, 3 columns on large screens */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          
          {/* Main Content - Takes full width on mobile, 2/3 on lg */}
          <div className="lg:col-span-2 bg-white rounded-xl shadow-sm p-5 sm:p-6 border border-gray-100">
            <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4 border-b border-gray-200 pb-6">
              <div className="flex items-start space-x-4">
                <img
                  className="w-16 h-16 object-contain rounded-md flex-shrink-0"
                  src={data?.companyId?.avatar || Logo}
                  alt="company logo"
                />
                <div>
                  <h1 className="text-xl font-semibold text-gray-900">
                    {data?.job?.jobTitle}
                  </h1>
                  <p className="text-gray-600">{data?.job?.employerName}</p>
                  <p className="text-gray-500 text-sm">{data?.job?.state}</p>
                </div>
              </div>

              <Link
                to={`/profile/${loggedInUser?.currentUser?._id}`}
                className="px-5 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors duration-200 text-sm font-medium whitespace-nowrap self-start sm:self-auto"
              >
                Back
              </Link>
            </div>

            <div className="mt-8 space-y-8">
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                  Application Status
                </h3>
                {renderStatus(data?.status)}
              </div>

              <div className="flex flex-wrap gap-2">
                <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm font-medium">
                  {data?.job?.workType}
                </span>
                {data?.job?.currency && data?.job?.salary && (
                  <span className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm font-medium">
                    {data?.job?.salary} {data?.job?.currency.split("-")[0]}
                  </span>
                )}
              </div>

              {data?.job?.jobSummary && (
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">Summary</h3>
                  <p className="text-gray-600 leading-relaxed">
                    {data?.job?.jobSummary}
                  </p>
                </div>
              )}

              {data?.job?.jobDescription && (
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">
                    Key Responsibilities
                  </h3>
                  <ul className="space-y-2 text-gray-600">
                    {data?.job?.jobDescription?.map((desc, index) => (
                      <li key={index} className="flex items-start">
                        <span className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 mr-2 flex-shrink-0"></span>
                        {desc}
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {data?.requireCoverLetter && (
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">
                    Cover Letter
                  </h3>
                  <p className="text-gray-600 bg-gray-50 p-4 rounded-lg">
                    {data?.coverLetter}
                  </p>
                </div>
              )}

              {data?.additionalQuestionResponse?.length > 0 && (
                <div className="space-y-4">
                  {data.additionalQuestionResponse.map((q, index) => (
                    <div key={index} className="bg-gray-50 p-4 rounded-lg">
                      <p className="text-gray-700 font-medium">{q.question}</p>
                      <p className="text-gray-600 mt-1">Answer: {q.response}</p>
                    </div>
                  ))}
                </div>
              )}

              <div className="space-y-4">
                <div className="flex items-center space-x-2 text-gray-700">
                  <BiFile className="w-5 h-5" />
                  <span className="font-medium">Resume/CV</span>
                </div>
                {data?.resume && (
                  <div className="bg-orange-50 p-4 rounded-lg flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                    <p className="text-orange-800 font-medium break-all sm:break-normal">
                      {data?.resume.split(";")[0]}
                    </p>
                    <button
                      onClick={openModal}
                      className="px-5 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 text-sm whitespace-nowrap"
                    >
                      Preview
                    </button>
                  </div>
                )}
              </div>

              {/* Interview Questions Section */}
              {data?.status === "Scheduled" && isInterviewDate && interviewData?.data?.questions?.length > 0 && (
                <div className="space-y-4">
                  <h3 className="font-semibold text-gray-900 mb-2">
                    Interview Questions
                  </h3>
                  <form onSubmit={handleSubmitResponses}>
                    {interviewData.data.questions.map((q, index) => (
                      <div key={index} className="bg-gray-50 p-4 rounded-lg mb-4">
                        <p className="text-gray-700 font-medium">{q.question}</p>
                        <textarea
                          value={responses[index] || q.response || ""}
                          onChange={(e) => handleResponseChange(index, e.target.value)}
                          className="w-full p-3 border rounded-lg mt-3 focus:ring-2 focus:ring-orange-500"
                          placeholder="Enter your response..."
                          disabled={q.response}
                          rows={3}
                        />
                      </div>
                    ))}
                    <button
                      type="submit"
                      className="px-8 py-3 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors duration-200 font-medium"
                      disabled={submitLoading || interviewData.data.questions.every((q) => q.response)}
                    >
                      {submitLoading ? "Submitting..." : "Submit Responses"}
                    </button>
                  </form>
                </div>
              )}

              {data?.status === "Offer" && (
                <Link
                  to={`/Offer/${latestOffer}/${data?._id}`}
                  className="inline-block px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 font-medium"
                >
                  View Offer
                </Link>
              )}

              {data?.status === "Scheduled" && (
                <button
                  onClick={() => setViewInterviewDetails(true)}
                  className="inline-block px-6 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors duration-200 font-medium"
                >
                  View Interview Details
                </button>
              )}
            </div>
          </div>

          {/* Similar Jobs Sidebar - Hidden on mobile, visible on lg */}
          <div className="hidden lg:block space-y-6">
            {getSimilarJobs(jobData, data?.job)?.map((eachJob, index) => (
              <JobCard key={index} data={eachJob} />
            ))}
          </div>
        </div>
      </div>

      {/* Modals */}
      <PDFPreviewModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        base64Data={data?.resume || ""}
      />

      <GeneralModal
        showCloseButton={true}
        open={viewInterviewDetail}
        handleClose={() => setViewInterviewDetails(false)}
        width={"lg"}
      >
        <InterviewDetails interviewData={interviewData?.data} />
      </GeneralModal>
    </div>
  );
}

export default ApplicantResponse;






























































